(() => {
  const dialog = document.getElementById('EveleWelcomeDialog');
  const KEY = 'evele-welcome-v1';
  const SESSION_KEY = 'evele-welcome-shown';
  const WEEK = 7 * 24 * 60 * 60 * 1000;
  let lastFocus;
  let scrollTimer;
  let ready = false;
  let shown = false;
  let previousOverflow = '';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { return {}; } };
  const save = (value) => { try { localStorage.setItem(KEY, JSON.stringify(value)); } catch { /* Works without persistent storage. */ } };
  const sessionShown = () => { try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch { return shown; } };
  const suppressed = () => { const state = read(); return state.subscribed || state.until > Date.now() || sessionShown(); };
  const markShown = () => {
    shown = true;
    save({ ...read(), until: Date.now() + WEEK });
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch { /* Current-page flag still applies. */ }
  };
  const open = (manual = false) => {
    if (!dialog || !dialog.showModal || dialog.open) return;
    if (!manual && (suppressed() || document.visibilityState !== 'visible' ||
      document.querySelector('dialog[open], cart-drawer.active, details[open] .search-modal, details[open] .menu-drawer') ||
      /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName))) return;
    lastFocus = document.activeElement;
    dialog.showModal();
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    markShown();
    (dialog.querySelector('[data-welcome-success]') || dialog.querySelector('[data-welcome-close]')).focus({ preventScroll: true });
  };
  const close = () => { if (dialog?.open) dialog.close(); };
  const progress = document.querySelector('[data-welcome-progress]');
  // Shopify's security challenge lives outside the dialog. Release the native
  // top layer on a valid submit so its challenge can receive focus and clicks.
  dialog?.querySelector('form')?.addEventListener('submit', () => {
    close();
    if (progress) progress.hidden = false;
  }, { capture: true });
  dialog?.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', close));
  dialog?.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
  });
  dialog?.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  document.querySelectorAll('[data-welcome-open]').forEach(button => {
    if (!dialog || !dialog.showModal) return;
    button.hidden = false;
    button.addEventListener('click', () => { if (progress) progress.hidden = true; open(true); });
  });
  document.querySelectorAll('[data-welcome-copy]').forEach(button => button.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText('EVELELOVE5'); button.textContent = 'Copied!'; }
    catch { button.textContent = 'Use EVELELOVE5'; }
  }));
  const success = document.querySelector('[data-welcome-success]');
  if (success) {
    save({ subscribed: true });
    const isPopupSubmission = location.hash === '#EveleWelcomePopup';
    if (isPopupSubmission) open(true);
    else success.focus({ preventScroll: false });
    return;
  }
  if (dialog?.querySelector('[data-welcome-error]') && location.hash === '#EveleWelcomePopup') { open(true); return; }
  if (!dialog || !dialog.showModal || window.Shopify?.designMode || suppressed()) return;
  // Let visitors browse first. The second opportunity covers visitors who stay at the top.
  setTimeout(() => { ready = true; if (window.scrollY > 120) open(); }, 15000);
  setTimeout(() => open(), 25000);
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => { if (ready && window.scrollY > 120) open(); }, 600);
  }, { passive: true });
})();
